<template>
    <main class="inner-layout">
        <Navigation v-if="user?.id" class="inner-layout__navigation-desktop" />
        <div class="inner-layout__inner flex flex-col">
            <Header v-show="isShowHeader" class="inner-layout__header-sec flex-0" :class="{ 'fixed' : isStatic }"
                :style-="!!user?.id ? 'left: var(--navigation-width)' : ''" />

            <div class="w-full lg:container mx-auto flex-0" :class="{
                'inner-layout__crumbs': !isStatic
            }">
                <Breadcrumbs class="inner-layout__breadcrumbs min-[768px]:mx-4" v-if="!($route.name === 'Home')" />
            </div>

            <div class="w-full lg:container mx-auto inner-layout__views flex-1">
                <slot />
            </div>

            <div class="container flex-0">
                <Footer class="inner-layout__footer" />
            </div>

            <div v-if="user?.id" class="inner-layout__bottom flex-0">
                <MobileNavigation class="inner-layout__navigation-mobile" />
            </div>
        </div>

        <Transition name="course-page__animation">
            <Confirmation v-if="isActiveConfirm" @onclose="closeContractRegistration"/>
        </Transition>
    </main>
</template>

<script setup>
import Header from '@/components/UI/header/index.vue'
import Breadcrumbs from '@/components/UI/breadcrumbs/index.vue'
import Navigation from '@/components/UI/navigation/index.vue'
import Footer from '@/components/UI/footer/Footer.vue'
import MobileNavigation from '@/components/UI/mobileNavigation/index.vue'
import {computed, onMounted, onUnmounted, ref, watch } from "vue";
import {useStore} from "vuex";

import Confirmation from '@/components/UI/confirmation/index.vue'

let lastPosition = window.scrollY
const store = useStore()
const isStatic = ref(true);

const isSidebarOpened = computed(() => store.getters.sidebarIsOpened)
const isSearchOpened = computed(() => store.getters.searchOverflow)
const isShowHeader = computed(() => store.getters.isHeaderVisible)
const user = computed(() => store.getters.user)

onMounted(() => {
    document.addEventListener('scroll', toggleHeader)
})

onUnmounted(() => {
    document.removeEventListener('scroll', toggleHeader)
})

const adjustHeaderPadding = () => {
    document.querySelector('header').style.left = isSidebarOpened.value ? 'var(--navigation-width)' : 'var(--navigation-width-minified)'
}

watch(isSidebarOpened, adjustHeaderPadding)

const toggleHeader = () => {
    if (window.scrollY < 250 || isSearchOpened.value) {
        store.commit('setHeaderVisibility', true)
        isStatic.value = true
        lastPosition = window.scrollY
        return
    }
    isStatic.value = false;
    store.commit('setHeaderVisibility', lastPosition >= window.scrollY)
    lastPosition = window.scrollY
}

const isActiveConfirm = computed(() => store.getters.isActiveConfirm)
const closeContractRegistration = () => {
    store.commit('setIsActiveConfirm', false)
}
</script>

<style lang="scss" scoped>
// @import '../assets/scss/layouts/inner-layout.scss';

.fixed {
    position: static;
    width: 100%;
    //@media only screen and (min-width: 1296px){
    //    width: calc(100% - 256px);
    //}
}
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
